var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.nowtime))]),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"tianqi"},[_c('v-mini-weather',{attrs:{"color":"#2ebcdd"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }